import { ExperimentTrackingString } from "../Contexts/ExperimentTrackingStringContext";

export function withExperimentTrackingStringProvider(
  comp: JSX.Element,
  experiment: string
) {
  return (
    <ExperimentTrackingString.Provider value={experiment}>
      {comp}
    </ExperimentTrackingString.Provider>
  );
}
